import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {ContentCardScratchpadState} from '../../scratchpad/contentCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';
import {taxonomy} from '@cl/shared';
import {TaxonomyType} from 'common/src/modules/taxonomy/taxonomy.enums';

const inputSchema = z.object({
  searchQuery: z.string().describe('The search query for finding feed columns'),
});

async function execute(
  params: ToolExecuteParams<typeof inputSchema, ContentCardScratchpadState>,
): Promise<ToolResult> {
  const {
    toolUtils: {agentScratchpad},
  } = params;
  const validatedScratchpad = validateAgentScratchpad<ContentCardScratchpadState>(
    agentScratchpad,
    NodeType.CONTENT_FEED,
  );

  const signals = await contentFeedsApi.getFeedSignals(validatedScratchpad.card.contentFeedId);
  const mapping = await taxonomy.taxonomyMappingsSubject.data[TaxonomyType.Content];
  const taxonomizedSignals = signals.map((signal) => {
    const taxonomyValue = mapping?.[signal.taxonomyKey || ''];

    return taxonomyValue
      ? {
          ...signal,
          name: taxonomyValue,
        }
      : signal;
  });

  validatedScratchpad.card.availableFeedColumns = taxonomizedSignals;

  return toolResult(JSON.stringify({columns: validatedScratchpad.card.availableFeedColumns}));
}

export default function searchContentFeedColumnsTool() {
  return tool({
    name: V2CardAgentToolName.SearchContentFeedColumns,
    displayName: 'Searching for content feed columns',
    description: 'Search for content feed columns for matching conditions.',
    inputSchema,
    execute,
  });
}
